import React from "react";

import { Typography } from "@mui/material";

import SkillsIllustration from "../../../assets/illustrations/skills.svg";

import skills from "../../../assets/data/skills.json";

import "./skills.scss";

const Skills = () => {
    return (
        <div className="skillsContainer flexContainer mt-1">
            <div className="skills fullHeight flexContainer flexCol">
                <Typography variant="h5">Skills</Typography>
                <div className="skillSet flexContainer flexRow skillsContainer">
                    {skills.skills.map(({ name, logo }) => (
                        <div key={name}>
                            <img
                                className="skillLogo"
                                src={logo}
                                alt={name}
                                loading="lazy"
                            />
                            <Typography className="p-1" variant="body2">
                                {name}
                            </Typography>
                        </div>
                    ))}
                </div>
            </div>
            <div className="fullSpace polygon">
                <div className="skillIllustrationContainer flexContainer fullHeight p-4">
                    <div className="skillIllustration p-4">
                        <img
                            src={SkillsIllustration}
                            alt="Skills Illustration"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Skills;
